import * as React from 'react';
import { TooltipDesktop, TooltipMobile, IconFunctionalInformation12 } from '@cian/ui-kit';
import classNames from 'classnames';
import { PRICE_DISCLAIMER_TEXT_MAP, TVillageOffersType } from '../../constants';
import * as styles from './PriceDisclaimer.css';

export interface IPriceDisclaimerProps {
  type: TVillageOffersType | undefined;
  mediaType?: 'desktop' | 'mobile';
}

export const PriceDisclaimer: React.VFC<IPriceDisclaimerProps> = ({ type, mediaType = 'desktop' }) => {
  if (!type) {
    return null;
  }

  const isMobile = mediaType === 'mobile';
  const TooltipComponent = mediaType === 'mobile' ? TooltipMobile : TooltipDesktop;

  return (
    <div className={classNames(styles['container'], { [styles['container-mobile']]: isMobile })}>
      <TooltipComponent
        theme="white"
        placement="right"
        title={<div className={styles['content']}>{PRICE_DISCLAIMER_TEXT_MAP[type]}</div>}
      >
        <div className={classNames(styles['icon'], { [styles['icon-mobile']]: isMobile })}>
          <IconFunctionalInformation12 color="primary_100" display="block" />
        </div>
      </TooltipComponent>
    </div>
  );
};
